import React from "react";
import { Hop, Trace } from "../../types/types";
import { Container } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";

type TraceDetailProps = {
    trace: Trace;
  };
const TraceDetail = (props: TraceDetailProps) => {
    const { trace } = props;
    const { hops, traceroute } = trace.geotraceroute;
    const data = {
      columns: [
        {
          field: "line",
          headerName: "Line #",
          width: 80,
          headerClassName: "Table--header",
        },
        {
          field: "ip",
          headerName: "IP",
          width: 150,
          headerClassName: "Table--header",
          renderCell: (params: any) => valueHelper(params.row, "ip")
        },
        {
          field: "rttn",
          headerName: "RTT",
          width: 100,
          headerClassName: "Table--header",
          renderCell: (params: any) => valueHelper(params.row, "rtt")
        },
        {
          field: "region",
          headerName: "Region",
          width: 100,
          headerClassName: "Table--header",
          renderCell: (params: any) => valueHelper(params.row, "region")
        },
        {
          field: "country",
          headerName: "Country",
          width: 100,
          headerClassName: "Table--header",
          renderCell: (params: any) => valueHelper(params.row, "country")
        },
        {
          field: "ASNumber",
          headerName: "AS Number",
          width: 100,
          headerClassName: "Table--header",
          renderCell: (params: any) => valueHelper(params.row, "ASNumber")
        },
        {
          field: "ASOrganizationName",
          headerName: "AS Org Name",
          width: 200,
          headerClassName: "Table--header",
          renderCell: (params: any) => valueHelper(params.row, "ASOrganizationName")
        },
      ],
      rows: hops.map((hop) => ({ ...hop, id: Number(hop.line) })),
    };
    return (
      <Container>
        <div style={{ height: 520, width: 780 }}>
          <DataGridPro
            {...data}
            loading={data.rows.length === 0}
            rowHeight={38}
            checkboxSelection={false}
            disableSelectionOnClick
            
          />
        </div>
      </Container>
    );
  };
  
  type HOPKEYS = "ip" | "line" | "rtt" | "host" | "region" | "country" | "city" | "ASNumber" | "ASOrganizationName";
  const valueHelper = (hop: Hop, key: HOPKEYS) => {
    return  ( hop[key] ? hop[key] : <span>*</span>);
  }

  export default TraceDetail;